import createRecurrence from 'owa-recurrence-utils/lib/createRecurrence';
import getSelectedRecurrenceKey from 'owa-recurrence-utils/lib/getSelectedRecurrenceKey';
import { RecurrenceConstants, RecurrenceTypes } from 'owa-recurrence-types';
import type RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import type { DisplayDate } from 'owa-datetime';

/**
 * Function to determine if same option is selected again and return the current recurrence to render.
 * If different option is selected, return the newly selected recurrence.
 * If a recurrence was selected and the user selects Custom, also return the current recurrence
 * @param currentRecurrence existing recurrence
 * @param selectedRecurrenceType selected recurrence type
 * @param startDate start date of the recurrence
 */
const getRecurrenceToRender = (
    currentRecurrence: RecurrenceType | null,
    selectedRecurrenceType: RecurrenceTypes,
    startDate: DisplayDate | null
): RecurrenceType => {
    if (selectedRecurrenceType === RecurrenceConstants.None || startDate == null) {
        return null;
    }

    const noExistingRecurrencePattern = currentRecurrence == null;
    const selectedSameOrCustom =
        selectedRecurrenceType ===
            getSelectedRecurrenceKey(currentRecurrence, true /* includeCustom */) ||
        selectedRecurrenceType === RecurrenceConstants.Custom;

    if (noExistingRecurrencePattern || !selectedSameOrCustom) {
        return createRecurrence(selectedRecurrenceType, startDate);
    }

    return currentRecurrence;
};

export default getRecurrenceToRender;
